//UnComments when you want to see preview on story-book
// import ChartJs from "chart.js";
// import { ChartComponentAPI, WindowCtx } from "../../types/charts";

// interface GetColorParameter {
//   type: string;
//   colors: string[];
//   columnsColor: string[] | string;
//   maxColor: number;
//   index: number;
//   border: boolean;
// }

// (function (ctx: Window & WindowCtx) {
//   if (ctx.ChartCtx && ctx.ChartCtx.define) {
//     console.log("registered");
//     ctx.ChartCtx.define("com.ava.chartjs", function (): ChartComponentAPI {
//       let defaultOptionList = {
//         bar: {
//           scales: { yAxes: [{ ticks: { beginAtZero: true } }] },
//           elements: { line: { tension: 0, borderWidth: 1 } },
//         },
//         line: {},
//         doughnut: {},
//         radar: {},
//         pie: {},
//         polarArea: {},
//         bubble: {},
//       };
//       function defaultOptionByType(type: keyof typeof defaultOptionList) {
//         return (
//           defaultOptionList[type] || {
//             elements: { line: { tension: 0, borderWidth: 3 } },
//           }
//         );
//       }
//       function defaultColors(type: string, index: number, alpha = 0.8) {
//         let colors = [
//           "hsla(156, 44%, 75%, " + alpha + ")",
//           "hsla(359, 59%, 75%, " + alpha + ")",
//           "rgba(255, 99, 132, " + alpha + ")",
//           "rgba(255, 159, 64, " + alpha + ")",
//           "rgba(255, 205, 86, " + alpha + ")",
//           "rgba(75, 192, 192, " + alpha + ")",
//           "rgba(54, 162, 235, " + alpha + ")",
//           "rgba(153, 102, 255, " + alpha + ")",
//           "rgba(121, 103, 147, " + alpha + ")",
//           "rgba(189, 223, 107, " + alpha + ")",
//           "rgba(153, 102, 255, " + alpha + ")",
//           "rgba(121, 103, 147, " + alpha + ")",
//           "rgba(189, 223, 107, " + alpha + ")",
//           "rgba(181, 203, 187, " + alpha + ")",
//         ];
//         let color = colors[index];
//         if (!["line", "bar", "radar", "area"].includes(type)) {
//           return [colors][index];
//         }
//         return color;
//       }

//       /**
//        * Convert PGDChart Axis API to ChartJS Axis API.
//        * example:
//        * ```json
//        * { "display": true,"label":"Hello, World","color": "red","lineWidth": 5,"dashWidth": 3,"dashOffset": 30 }
//        * ```
//        * @param {ChartAPI.Axis} data
//        */
//       function axisToChartJS(
//         data: { display: any; label: any; color: any; dashWidth: number; dashOffset: number; lineWidth: number },
//         type: string,
//         axis: string | string[]
//       ) {
//         if (typeof data !== "object") {
//           return;
//         }
//         let objBuilder = {};
//         if (typeof data.display === "boolean") {
//           Object.assign(objBuilder, { display: data.display });
//         }
//         if (typeof data.label === "string") {
//           Object.assign(objBuilder, {
//             scaleLabel: { display: !!data.label, labelString: data.label },
//           });
//         }
//         if (
//           typeof data.color === "string" ||
//           !isNaN(data.dashWidth) ||
//           !isNaN(data.dashOffset) ||
//           !isNaN(data.lineWidth) ||
//           ["line", "bar", "area"].includes(type)
//         ) {
//           Object.assign(objBuilder, {
//             gridLines: {
//               borderDash: [data.dashWidth || 0, !isNaN(data.dashOffset) ? data.dashOffset : data.dashWidth || 0],
//               lineWidth: typeof data.lineWidth === "number" ? data.lineWidth : 1,
//               color: typeof data.color === "string" ? data.color : "rgba(0, 0, 0, 0.1)",
//               display: true,
//               drawBorder: true,
//               drawOnChartArea: true,
//               drawTicks: true,
//               offsetGridLines: axis.indexOf("x") >= 0,
//               tickMarkLength: 10,
//             },
//           });
//         }
//         return objBuilder;
//       }
//       function getColor({ type, colors, columnsColor, index, border }: GetColorParameter): any {
//         if (columnsColor instanceof Array && columnsColor.length >= index) {
//           return columnsColor[index];
//         }
//         if (columnsColor && typeof columnsColor === "string" && columnsColor.length > 3) {
//           return columnsColor;
//         }
//         if (colors instanceof Array) {
//           if (!["line", "bar", "area", "radar"].includes(type)) {
//             return colors;
//           } else {
//             return colors[index];
//           }
//         }
//         if (typeof colors === "string") {
//           return colors;
//         }
//         return defaultColors(type, index, border ? 1 : 0.8);
//       }
//       function supportTypes(): Record<string, boolean | string[]> {
//         return {
//           bar: ["line", "area"],
//           line: ["area"],
//           area: ["line"],
//           radar: [],
//           pie: [],
//           doughnut: [],
//           polarArea: [],
//         };
//       }
//       return {
//         id: "com.ava.chartjs",
//         name: "Chart.Js",
//         supportTypes: supportTypes(),
//         getInspector: function (_type: string) {
//           return {
//             sidebar: {
//               action: {
//                 eventTypes: [],
//               },
//               style: {
//                 text: false,
//                 boxSize: true,
//                 background: true,
//                 border: true,
//                 appearance: true,
//                 boxShadow: true,
//               },
//             },
//           };
//         },
//         toDataset: function (dataTable: any): any {
//           this._dataTable = dataTable;
//           var rows = this._dataTable.rows;
//           var columns = this._dataTable.columns;
//           var options = this._dataTable.options;
//           var columnsColor = this._dataTable.colors;
//           this._labels = rows.map((item: any[]) => {
//             return item[0];
//           });
//           var sr = rows.map((item: string | any[]) => {
//             return item.slice(1);
//           });
//           this._defaultBg = this._type === "line" ? "transparent" : null;
//           this._datasets = columns.slice(1).map((item: any, index: number) => {
//             var backgroundColor = getColor({
//               type: this._type,
//               colors: this._colors,
//               columnsColor,
//               maxColor: sr.length,
//               index,
//               border: false,
//             });
//             var borderColor = getColor({
//               type: this._type,
//               colors: this._colors,
//               columnsColor,
//               maxColor: sr.length,
//               index,
//               border: true,
//             });
//             let dataObj = {
//               label: item,
//               backgroundColor: backgroundColor,
//               fill: !!this._fillArea,
//               borderColor: borderColor,
//               data: sr.map((s: { [x: string]: any }) => s[index]),
//             };
//             if (options) {
//               let _type: string = !!this._fillArea ? "area" : this._type;
//               let combine = supportTypes()[_type];
//               if (combine) {
//                 options.forEach((ot: { col: any; type: string }) => {
//                   if (ot.col === item) {
//                     var type = ot.type;
//                     if (Array.isArray(combine) && combine.includes(type)) {
//                       var fill = ot.type === "area";
//                       if (ot.type === "area") {
//                         type = "line";
//                       }
//                       Object.assign(dataObj, { type: type, fill: fill });
//                     }
//                   }
//                 });
//               }
//             }
//             return dataObj;
//           });
//           return { labels: this._labels, datasets: this._datasets };
//         },
//         update: function (dataTable: any) {
//           if (this._chartjs) {
//             if (dataTable) {
//               let datasets = this.toDataset(dataTable);
//               if (this._chartjs.data !== datasets) {
//                 this._chartjs.data = datasets;
//               }
//             }
//             this._chartjs.update();
//           }
//         },
//         updateConfig: function (config: any) {
//           if (config && config.colors) {
//             this._colors = config.colors;
//           } else if (this._chartjs) {
//             Object.assign(this._chartjs.config, config);
//           }
//         },
//         axis: function (axes: { x: any; y: any }, type: any) {
//           if (typeof axes !== "object") {
//             return;
//           }
//           if (typeof axes.x === "object") {
//             if (this._chartjs && this._chartjs.config) {
//               Object.assign(this._chartjs.config.options.scales.xAxes[0], axisToChartJS(axes.x, type, "x"));
//             }
//           }
//           if (typeof axes.y === "object") {
//             if (this._chartjs && this._chartjs.config) {
//               Object.assign(this._chartjs.config.options.scales.yAxes[0], axisToChartJS(axes.y, type, "y"));
//             }
//           }
//         },
//         changeTitle: function (titleOption: { display: boolean; text: any }) {
//           if (typeof titleOption === "object" && this._chartjs) {
//             titleOption.display = !!titleOption.text;
//             Object.assign(this._chartjs.config.options.title, titleOption);
//             this._chartjs.update();
//           }
//         },
//         resize: function () {
//           if (this._chartjs) this._chartjs.resize();
//         },
//         destroy: function () {
//           if (this._chartjs) this._chartjs.destroy();
//         },
//         render: function ($: { Canvas: any }, _config: { dataTable: any; options: any; type: string }) {
//           this._dataTable = _config.dataTable;
//           this._options = _config.options;
//           this._type = _config.type;
//           this._fillArea = _config.type === "area";
//           if (_config.type === "area") {
//             this._type = "line";
//           }
//           this.toDataset(this._dataTable);
//           this._chartjs = new ChartJs($.Canvas, {
//             type: this._type,
//             data: {
//               labels: this._labels,
//               datasets: this._datasets,
//             },
//             options: Object.assign({}, defaultOptionByType(this._type), _config.options),
//           });
//           this._config = this._chartjs.config;
//           return this;
//         },
//       };
//     });
//   }
//   // @ts-ignore
// })(window);

//new provider can preview on PGD
/// <reference path="../../types/index.d.ts" />
import ChartJs from "chart.js";
//options
export const defaultOptions: { [key: string]: any } = {
  bar: {
    scales: { yAxes: [{ ticks: { beginAtZero: true } }] },
    elements: { line: { tension: 0, borderWidth: 1 } },
  },
  line: {},
  doughnut: {},
  radar: {},
  pie: {},
  polarArea: {},
  bubble: {},
};

export function getDefaultOptionByType(type: string) {
  return (
    defaultOptions[type] || {
      elements: { line: { tension: 0, borderWidth: 3 } },
    }
  );
}

//axis
export function axisToChartJS(
  data: { display: any; label: any; color: any; dashWidth: number; dashOffset: number; lineWidth: number },
  type: string,
  axis: string | string[]
) {
  if (typeof data !== "object") {
    return;
  }
  let objBuilder = {};
  if (typeof data.display === "boolean") {
    Object.assign(objBuilder, { display: data.display });
  }
  if (typeof data.label === "string") {
    Object.assign(objBuilder, {
      scaleLabel: { display: !!data.label, labelString: data.label },
    });
  }
  if (
    typeof data.color === "string" ||
    !isNaN(data.dashWidth) ||
    !isNaN(data.dashOffset) ||
    !isNaN(data.lineWidth) ||
    ["line", "bar", "area"].includes(type)
  ) {
    Object.assign(objBuilder, {
      gridLines: {
        borderDash: [data.dashWidth || 0, !isNaN(data.dashOffset) ? data.dashOffset : data.dashWidth || 0],
        lineWidth: typeof data.lineWidth === "number" ? data.lineWidth : 1,
        color: typeof data.color === "string" ? data.color : "rgba(0, 0, 0, 0.1)",
        display: true,
        drawBorder: true,
        drawOnChartArea: true,
        drawTicks: true,
        offsetGridLines: axis.indexOf("x") >= 0,
        tickMarkLength: 10,
      },
    });
  }
  return objBuilder;
}

//supportTypes
type ChartSupportTypes = {
  bar: string[];
  line: string[];
  area: string[];
  radar: string[];
  pie: string[];
  doughnut: string[];
  halfDoughnut: string[];
  polarArea: string[];
  barStacked: string[];
  horizontalBar: string[];
  horizontalBarStacked: string[];
};

export function supportTypes(): ChartSupportTypes {
  return {
    bar: ["line", "area"],
    line: ["area"],
    area: ["line"],
    radar: [],
    pie: [],
    doughnut: [],
    halfDoughnut: [],
    polarArea: [],
    barStacked: [],
    horizontalBar: [],
    horizontalBarStacked: [],
  };
}

//Inspector
export function getInspector(_type: string) {
  return {
    sidebar: {
      action: {
        eventTypes: [],
      },
      style: {
        text: false,
        boxSize: true,
        background: true,
        border: true,
        appearance: true,
        boxShadow: true,
      },
    },
  };
}

//color
export function defaultColors(type: string, index: number, alpha = 0.8) {
  let colors = [
    "hsla(156, 44%, 75%, " + alpha + ")",
    "hsla(359, 59%, 75%, " + alpha + ")",
    "rgba(255, 99, 132, " + alpha + ")",
    "rgba(255, 159, 64, " + alpha + ")",
    "rgba(255, 205, 86, " + alpha + ")",
    "rgba(75, 192, 192, " + alpha + ")",
    "rgba(54, 162, 235, " + alpha + ")",
    "rgba(153, 102, 255, " + alpha + ")",
    "rgba(121, 103, 147, " + alpha + ")",
    "rgba(189, 223, 107, " + alpha + ")",
    "rgba(153, 102, 255, " + alpha + ")",
    "rgba(121, 103, 147, " + alpha + ")",
    "rgba(189, 223, 107, " + alpha + ")",
    "rgba(181, 203, 187, " + alpha + ")",
  ];
  let color = colors[index];
  if (!["line", "bar", "radar", "area", "horizontalBar"].includes(type)) {
    return [colors][index];
  }
  return color;
}

export function getColor({ type, colors, columnsColor, index, border }: any) {
  if (columnsColor instanceof Array && columnsColor.length >= index) {
    return columnsColor[index];
  }
  if (columnsColor && typeof columnsColor === "string" && columnsColor.length > 3) {
    return columnsColor;
  }
  if (colors instanceof Array) {
    if (["pie", "doughnut", "polarArea"].includes(type)) {
      return colors;
    } else {
      return colors[index];
    }
  }
  if (typeof colors === "string") {
    return colors;
  }
  return defaultColors(type, index, border ? 1 : 0.8);
}

//dataset
export function prepareDataset({ columns, columnsColor, options, type, colors, fillArea, series }: any) {
  return columns.slice(1).map((item: any, index: string | number) => {
    var backgroundColor = getColor({
      type: type,
      colors: colors,
      columnsColor,
      series,
      index,
      border: false,
    });
    var borderColor = getColor({
      type: type,
      colors: colors,
      columnsColor,
      series,
      index,
      border: true,
    });
    let dataObj = {
      label: item,
      backgroundColor: backgroundColor,
      fill: !!fillArea,
      borderColor: borderColor,
      data: series.map((s: { [x: string]: any }) => s[index]),
    };
    if (options) {
      let chartType: keyof ChartSupportTypes = !!fillArea ? "area" : type;
      let combine = supportTypes()[chartType];
      if (combine) {
        options.forEach((ot: { col: any; type: string }) => {
          if (ot.col === item) {
            var combindType = ot.type;
            if (combine.includes(combindType)) {
              var fill = ot.type === "area";
              if (ot.type === "area") {
                combindType = "line";
              }
              Object.assign(dataObj, { type: combindType, fill: fill });
            }
          }
        });
      }
    }
    return dataObj;
  });
}

interface IChartJsComponent extends chartAPI.ChartComponent {
  convert2ChartJsData(dataTable: chartAPI.PGDChartData): { labels: string[]; datasets: any[] };
}

let chartID = "com.oneweb.chartjs";
class ChartJSComponent implements IChartJsComponent {
  id: string;
  name: string;
  displayName?: string;
  supportTypes: any;
  _dataTable!: chartAPI.PGDChartData;
  _labels!: string[];
  _defaultBg!: string | null;
  _datasets: any;
  _type!: string;
  _colors: any;
  _fillArea: any;
  _chartjs: any;
  _options: any;
  _config: any;
  constructor() {
    this.id = chartID;
    this.displayName = "ChartJs Component";
    this.name = "Chart.Js";
    this.supportTypes = supportTypes();
  }
  getInspector(type: string): chartAPI.PGDInspectorAPI {
    return getInspector(type);
  }

  convert2ChartJsData(dataTable: chartAPI.PGDChartData) {
    this._dataTable = dataTable;
    var rows = dataTable.rows;
    var columns = dataTable.columns;
    var options = dataTable.options;
    var columnsColor = dataTable.colors;
    this._labels = rows.map((item) => {
      return item[0];
    });
    var series = rows.map((item) => {
      return item.slice(1);
    });
    this._defaultBg = this._type === "line" ? "transparent" : null;
    this._datasets = prepareDataset({
      columns,
      series,
      options,
      columnsColor,
      type: this._type,
      colors: this._colors,
      fillArea: this._fillArea,
    });
    return { labels: this._labels, datasets: this._datasets };
  }
  update(dataTable: chartAPI.PGDChartData) {
    if (this._chartjs) {
      if (dataTable) {
        let datasets = this.convert2ChartJsData(dataTable);
        if (this._chartjs.data !== datasets) {
          this._chartjs.data = datasets;
        }
      }
      this._chartjs.update();
    }
  }
  updateConfig(config: any) {
    if (config && config.colors) {
      this._colors = config.colors;
    } else if (this._chartjs) {
      Object.assign(this._chartjs.config, config);
    }
  }
  axis(axes: { x: any; y: any }, type: any) {
    if (typeof axes !== "object") {
      return;
    }
    if (typeof axes.x === "object") {
      if (this._chartjs && this._chartjs.config) {
        Object.assign(this._chartjs.config.options.scales.xAxes[0], axisToChartJS(axes.x, type, "x"));
      }
    }
    if (typeof axes.y === "object") {
      if (this._chartjs && this._chartjs.config) {
        Object.assign(this._chartjs.config.options.scales.yAxes[0], axisToChartJS(axes.y, type, "y"));
      }
    }
  }
  changeTitle(titleOption: { display: boolean; text: any }) {
    if (typeof titleOption === "object" && this._chartjs) {
      titleOption.display = !!titleOption.text;
      Object.assign(this._chartjs.config.options.title, titleOption);
      this._chartjs.update();
    }
  }
  resize() {
    if (this._chartjs) this._chartjs.resize();
  }
  destroy() {
    if (this._chartjs) this._chartjs.destroy();
  }
  render(
    $: {
      Canvas:
        | string
        | CanvasRenderingContext2D
        | HTMLCanvasElement
        | ArrayLike<CanvasRenderingContext2D | HTMLCanvasElement>;
    },
    _config: { dataTable: chartAPI.PGDChartData; options: { scales: { xAxes: any[]; yAxes: any[] } }; type: string }
  ) {
    this._dataTable = _config.dataTable;
    this._options = _config.options;
    this._type = _config.type;
    this._fillArea = _config.type === "area";
    if (_config.type === "area") {
      this._type = "line";
    }
    if (_config.type === "barStacked" || _config.type === "horizontalBarStacked") {
      this._type = _config.type === "barStacked" ? "bar" : "horizontalBar";
      let stacked = true;
      let xAxes = [{ stacked }];
      let yAxes = [{ stacked }];
      let scales = { xAxes, yAxes };
      if (!_config.options.scales) {
        Object.assign(_config.options, {
          scales,
        });
      } else if (_config.options.scales) {
        if (!_config.options.scales.xAxes) {
          Object.assign(_config.options.scales, { xAxes });
        } else if (_config.options.scales.xAxes) {
          Object.assign(_config.options.scales.xAxes[0], { stacked });
        }
        if (!_config.options.scales.yAxes) {
          Object.assign(_config.options.scales, { yAxes });
        } else if (_config.options.scales.yAxes) {
          Object.assign(_config.options.scales.yAxes[0], { stacked });
        }
      }
    }
    if (_config.type === "halfDoughnut") {
      this._type = "doughnut";
      Object.assign(_config.options, {
        rotation: 1 * Math.PI,
        circumference: 1 * Math.PI,
      });
    }
    if (["radar", "pie", "doughnut", "polarArea", "halfDoughnut"].includes(_config.type)) {
      // ปิดแกน x และ y
      _config.options.scales = {
        xAxes: [],
        yAxes: [],
      };
    }
    this.convert2ChartJsData(this._dataTable);
    this._chartjs = new ChartJs($.Canvas, {
      type: this._type,
      data: {
        labels: this._labels,
        datasets: this._datasets,
      },
      options: Object.assign(
        {
          responsive: true,
          maintainAspectRatio: false,
        },
        getDefaultOptionByType(this._type),
        _config.options
      ),
    });
    this._config = this._chartjs.config;
    return this;
  }
}

(function (ctx: chartAPI.WindowCtx) {
  if (ctx.ChartCtx && ctx.ChartCtx.define) {
    console.log("registered");
    ctx.ChartCtx.define(chartID, ChartJSComponent);
  }
  // @ts-ignore
})(window);
